/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommContentTemplate2ViewProps } from './ecomm-content-template-2';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommContentTemplate2ViewProps>}
 */
export class EcommContentTemplate2View extends React.PureComponent<IEcommContentTemplate2ViewProps> {
    public render(): JSX.Element | null {
        const { config, description, anchorID, TemplateContainerStyle } = this.props;

        const resultStyle =
            config.className && config.className !== ''
                ? `${TemplateContainerStyle.className}` + ` ` + `${config.className}`
                : TemplateContainerStyle.className;

        if (anchorID) {
            const style = `anchor ` + `${resultStyle}`;

            return (
                <div id={anchorID} className={style}>
                    {this._renderImage()}
                    <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {description}
                    </p>
                </div>
            );
        }

        return (
            <div className={resultStyle}>
                {this._renderImage()}
                <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                    {description}
                </p>
            </div>
        );
    }

    private _renderImage(): JSX.Element | null {
        const { firstImage, secondImage, ImageContainerStyle, FirstContainerStyle, SecondContainerStyle, NoImage } = this.props;

        const imgFirst =
            firstImage && firstImage.src ? <img src={firstImage.src} alt='' role='presentation' /> : <div className={NoImage.className} />;

        const imgSecond =
            secondImage && secondImage.src ? (
                <img src={secondImage.src} alt='' role='presentation' />
            ) : (
                <div className={NoImage.className} />
            );

        if (secondImage && secondImage.src) {
            return (
                <div className={ImageContainerStyle.className}>
                    <div className={FirstContainerStyle.className}>{imgFirst}</div>
                    <div className={SecondContainerStyle.className}>{imgSecond}</div>
                </div>
            );
        }

        return (
            <div className={ImageContainerStyle.className}>
                <div className='col-12'>{imgFirst}</div>
            </div>
        );
    }
}

export default EcommContentTemplate2View;
